<!-- src/components/AnimatedWrapper.vue -->
<template>
  <div ref="animatedContainer">
    <slot></slot>
  </div>
</template>

<script>
import anime from 'animejs/lib/anime.es.js';

export default {
  name: 'AnimatedWrapper',

  props: {
    animationConfig: {
      type: Object,
      required: true,
    },
    animateOnEnter: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    if (this.animateOnEnter) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.triggerAnimation();
            observer.disconnect();
          }
        });
      });
      observer.observe(this.$refs.animatedContainer);
    } else {
      this.triggerAnimation();
    }
  },

  methods: {
    triggerAnimation() {
      anime({
        targets: this.$refs.animatedContainer.children,
        ...this.animationConfig,
      });
    },
  },
};
</script>

<style scoped></style>
